/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:informationrequest:view:list */

export interface ViewListBlockParams {
	containerRID: string;
}
/** Block parameters for urn:block:informationrequest:view:client-share-link-form */

export interface ViewClientShareLinkFormBlockParams {
	informationRequestRID: string;
}
/** Block parameters for urn:block:informationrequest:view:grant-access-list */

export interface ViewGrantAccessListBlockParams {
	informationRequestRIDs: string[];
}
/** Block parameters for urn:block:informationrequest:provider */

export interface ProviderBlockParams {
	containerRID: string;
}
/** Zone parameters for urn:zone:informationrequest:provider:children */

export interface ProviderChildrenZoneParams {}
/** Contract Data for urn:zone:informationrequest:provider:children */

export interface ProviderChildrenContractData {
	canCreateInfoReq?: boolean;
}

export namespace BlockNames {
	export const ViewList = 'urn:block:informationrequest:view:list' as const;
	export type ViewList = 'urn:block:informationrequest:view:list';
	export const ViewClientShareLinkForm =
		'urn:block:informationrequest:view:client-share-link-form' as const;
	export type ViewClientShareLinkForm =
		'urn:block:informationrequest:view:client-share-link-form';
	export const ViewGrantAccessList =
		'urn:block:informationrequest:view:grant-access-list' as const;
	export type ViewGrantAccessList = 'urn:block:informationrequest:view:grant-access-list';
	export const Provider = 'urn:block:informationrequest:provider' as const;
	export type Provider = 'urn:block:informationrequest:provider';
}

export namespace ZoneTypes {
	export const ProviderChildren =
		'urn:zone:informationrequest:provider:children' as const;
	export type ProviderChildren = 'urn:zone:informationrequest:provider:children';
}

export type ViewListProps = ShellProps & BlockParams & ViewListBlockParams;
export type ViewClientShareLinkFormProps = ShellProps &
	BlockParams &
	ViewClientShareLinkFormBlockParams;
export type ViewGrantAccessListProps = ShellProps &
	BlockParams &
	ViewGrantAccessListBlockParams;
export type ProviderProps = ShellProps & BlockParams & ProviderBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:informationrequest:view:list']: BlockParams & ViewListBlockParams;
		['urn:block:informationrequest:view:client-share-link-form']: BlockParams &
			ViewClientShareLinkFormBlockParams;
		['urn:block:informationrequest:view:grant-access-list']: BlockParams &
			ViewGrantAccessListBlockParams;
		['urn:block:informationrequest:provider']: BlockParams & ProviderBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:informationrequest:provider:children']: ProviderChildrenZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:informationrequest:provider:children']: ProviderChildrenContractData;
	}
}
